import { toast } from "react-toastify";
import { CardGrid } from "./CardGrid/CardGrid";
import { useEffect, useState } from "react";
import { _AttentionService } from "../../../../../../../../../core/services/dataBean/QuickEntityCatalog";
import useDataBean from "../../../../../../../../../core/services/dataBean/useDataBean";
import "./AttentionServiceCardTree.css"

export const AttentionServiceCardTree = ({ idAttentionPoint, onSelect }) => {
    const { instance } = useDataBean(_AttentionService);

    const [rootList, setRootList] = useState([]);
    const [children, setChildren] = useState([]);
    const [breadcrumb, setBreadcrumb] = useState([]);
    const [selectedLeaf, setSelectedLeaf] = useState<number | null>(null);

    useEffect(() => {
        if (idAttentionPoint) loadRoot();
    }, [idAttentionPoint]);

    const loadRoot = async () => {
        try {
            const resp = await instance.getTreeForAttentionID(idAttentionPoint, null);
            setRootList(resp.Childs);
            setBreadcrumb([]);
            setChildren([]);
        } catch (err) {
            toast.error("Error cargando servicios");
        }
    };

    const loadChildren = async (item) => {
        try {
            if (item.ChildrenCount === 0) {
                setSelectedLeaf(item.IDLn);
                onSelect(item);
                return;
            }

            const resp = await instance.getAttentionIDChilds(
                item.IDLn,
                null,
                item.IDAttentionOffice,
                null
            );

            setBreadcrumb(prev => {
                const exists = prev.some(b => b.IDLn === item.IDLn);
                return exists ? prev : [...prev, item];
            });

            setSelectedLeaf(null);
            setChildren(resp);

        } catch (err) {
            toast.error("Error cargando subservicios");
        }
    };

    const resetFromBreadcrumb = (index) => {
        if (index === -1) {
            return loadRoot();
        }

        const newPath = breadcrumb.slice(0, index + 1);
        setBreadcrumb(newPath);
        loadChildren(newPath[index]);
    };

    return (
        <div className="service-card-tree">
            <div className="breadcrumb-container mb-3">
                <span
                    className="breadcrumb-item breadcrumb-root"
                    onClick={() => resetFromBreadcrumb(-1)}
                >
                    Inicio
                </span>

                {breadcrumb.map((b, idx) => (
                    <span key={idx}>
                        {" > "}
                        <span
                            className="breadcrumb-item"
                            onClick={() => resetFromBreadcrumb(idx)}
                        >
                            {b.Name}
                        </span>
                    </span>
                ))}
            </div>

            {breadcrumb.length === 0 ? (
                <CardGrid list={rootList} onClick={loadChildren} selectedLeaf={selectedLeaf} />
            ) : (
                <CardGrid list={children} onClick={loadChildren} selectedLeaf={selectedLeaf} />
            )}
        </div>
    );
};
